import { useState } from "react";
import Pagination from '@mui/material/Pagination';
import Stack from "@mui/material/Stack";


const dummyNotifications = [
    {
        id: 1,
        name: 'TA',
        assistant: 'Senior Agricultural Officer (TA)',
        state: 'Joint Director of Agriculture (WM)',
        appellate: 'Additional Director of Agriculture (CP)'
    },
    {
        id: 2,
        name: 'TR',
        assistant: 'Assistant Director of Agriculture (TR)',
        state: 'Joint Director of Agriculture (WM)',
        appellate: 'Additional Director of Agriculture (CP)'
    },
    {
        id: 3,
        name: 'TB',
        assistant: 'Assistant Director of Agriculture (TB)',
        state: 'Deputy Director of Agriculture (CD)',
        appellate: 'Additional Director of Agriculture (CP)'
    },
    {
        id: 4,
        name: 'TD',
        assistant: 'Plant Protection Officer',
        state: 'Joint Director of Agriculture (PP)',
        appellate: 'Additional Director of Agriculture (CP)'
    },
    {
        id: 5,
        name: 'TF',
        assistant: 'Senior Agricultural Officer (TF)',
        state: 'Joint Director of Agriculture (PP)',
        appellate: 'Additional Director of Agriculture (CP)'
    }
];

// Number of items to display per page
const ITEMS_PER_PAGE = 5;
const PMU = () => {

    const [currentPage, setCurrentPage] = useState(1);

    // Calculate the total number of pages
    const totalPages = Math.ceil(dummyNotifications.length / ITEMS_PER_PAGE);

    // Get the notifications for the current page
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    const currentNotifications = dummyNotifications.slice(startIndex, endIndex);

    // Handle page change from the Pagination component
    const handlePageChange = (event, page) => {
        setCurrentPage(page);
    };
    return (
        <>
            <div className='p-[10px] w-[100%] text-black bg-[#14608405]'>
                <div className="border-l-2 border-t-2 border-r-2 p-3 font-bold text-center">
                    <p>RTI - DETAILS OF THE STATE PUBLIC INFORMATION OFFICERS</p>
                </div>
                <div className="border-2 p-3 font-bold text-center">
                    <p>THE DIRECTORATE OF AGRICULTURE DEVELOPMENT & FARMERS'WELFARE DEPARTMENT, VIKAS BHAVAN, THIRUVANANTHAPURAM</p>
                </div>
                <div className="overflow-x-auto w-full ">
                    <table border='2' className="w-full border-collapse border-2 rounded-lg overflow-hidden shadow-lg">
                        <thead className="text-black">
                            <tr>
                                <th className="py-3 px-4 text-left border-r border-b">Name of Section</th>
                                <th className="py-3 px-4 text-left border-r border-b">Assistant Public Information Officer, Designation</th>
                                <th className="py-3 px-4 text-left border-r border-b">State Public Information Officer, Designation</th>
                                <th className="py-3 px-4 text-left border-r border-b">Appellate Authority, Designation</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentNotifications.length > 0 ? (
                                currentNotifications.map((notification, index) => (
                                    <tr key={notification.id} className="even:bg-gray-50 hover:bg-gray-100 transition-colors duration-200">
                                        <td className="py-3 px-4 border-b border-r border-gray-200">{index + 1}</td>
                                        <td className="py-3 px-4 border-b border-r border-gray-200">{notification.name}</td>
                                        <td className="py-3 px-4 border-b border-r border-gray-200">{notification.assistant}</td>
                                        <td className="py-3 px-4 border-b border-r border-gray-200">{notification.state}</td>
                                        <td className="py-3 px-4 border-b border-gray-200">{notification.appellate}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className="py-4 text-center text-gray-500 border-b">No notifications available.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <div className="w-full flex justify-center mt-8 mb-10">
                    <Stack spacing={2}>
                        <Pagination
                            count={totalPages}
                            page={currentPage}
                            onChange={handlePageChange}
                            color="primary"
                            showFirstButton
                            showLastButton
                            size="large"
                        />
                    </Stack>
                </div>
            </div>
        </>
    )
}

export default PMU